import React, { Component } from "react";
import { connect } from "react-redux";
import { docPermConstants } from "../../../../_constants/permissionConstants";

class ProjContractorDetails extends Component {
  handleClick_editPcDetails = (e) => {
    e.preventDefault();
    this.props.toggleEditPcDetailsModal();
  };

  render() {
    const { projContractor, permissions } = this.props;
    return (
      <React.Fragment>
        <div className="card">
          <div className="card-header bg-lightgray">Contractor Details</div>
          <div className="card-body p-3">
            {projContractor ? (
              <React.Fragment>
                <h3 className="card-title mx-0">{projContractor.name}</h3>
                <h5 className="card-subtitle text-muted mx-0">
                  {projContractor.isPrime === false
                    ? "Subcontractor"
                    : projContractor.isPrime === true && "Prime Contractor"}
                </h5>
              </React.Fragment>
            ) : (
              <h5 className="text-muted">No projContractor selected</h5>
            )}
            {projContractor && (
              <React.Fragment>
                <div className="row mx-0 pl-0 mt-2">
                  <div className="col pl-0">
                    <ul className="list-group-flush border-bottom border-top mb-2 pl-0">
                      <li className="list-group-item py-1 pl-1">
                        <div className="row">
                          <div className="col pr-1">
                            <b>Abbreviation:</b>
                          </div>
                          <div className="col pl-1">
                            {projContractor.projectAbbreviation ||
                              projContractor.abbreviation ||
                              "(N/A)"}
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item py-1 pl-1">
                        <div className="row">
                          <div className="col pr-1">
                            <b>Labor Count:</b>
                          </div>
                          <div className="col pl-1">{projContractor.laborCount || 0}</div>
                        </div>
                      </li>
                      <li className="list-group-item py-1 pl-1">
                        <div className="row">
                          <div className="col pr-1">
                            <b>Equipment Count:</b>
                          </div>
                          <div className="col pl-1">
                            {projContractor.equipmentCount || 0}
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item py-1 pl-1">
                        <div className="row">
                          <div className="col pr-1">
                            <b>Contact Name:</b>
                          </div>
                          <div className="col pl-1">
                            {projContractor.contactFullName || "(N/A)"}
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item py-1 pl-1">
                        <div className="row">
                          <div className="col pr-1">
                            <b>Contact Title:</b>
                          </div>
                          <div className="col pl-1">
                            {projContractor.contactTitle || "(N/A)"}
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item py-1 pl-1">
                        <div className="row">
                          <div className="col pr-1">
                            <b>Phone:</b>
                          </div>
                          <div className="col pl-1">
                            {projContractor.phone || "(N/A)"}
                          </div>
                        </div>
                      </li>
                      <li className="list-group-item py-1 pl-1">
                        <div className="row">
                          <div className="col pr-1">
                            <b>Address:</b>
                          </div>
                          <div className="col pl-1">
                            {projContractor.address || "(N/A)"}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="form-row form-group">
                  <button
                    type="button"
                    name="editContractorDetails"
                    id="editContractorDetails"
                    className="btn btn-secondary mr-2"
                    onClick={this.handleClick_editPcDetails}
                    disabled={!permissions.includes(docPermConstants.EDIT)}
                  >
                    Edit...
                  </button>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projContractor: state.contractors.openProjContractorDetails[ownProps.projectId]
    ? state.contractors.openProjContractorDetails[ownProps.projectId][
        ownProps.contractorId
      ] || null
    : null,
});

export default connect(mapStateToProps)(ProjContractorDetails);
